module.exports = __webpack_public_path__ + "static/media/project_12.8c80c1b0.svg";